import { render, staticRenderFns } from "./BusinessTaskDetail.vue?vue&type=template&id=efb64b4e&scoped=true&"
import script from "./BusinessTaskDetail.vue?vue&type=script&lang=js&"
export * from "./BusinessTaskDetail.vue?vue&type=script&lang=js&"
import style0 from "./BusinessTaskDetail.vue?vue&type=style&index=0&id=efb64b4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb64b4e",
  null
  
)

export default component.exports